import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/config";

export const WhatsAppButton = () => (
  <a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Escríbeme por WhatsApp"
    data-testid="whatsapp-float-button"
    className="wa-pulse fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-sage text-white shadow-lg transition-transform duration-300 hover:scale-105 md:h-16 md:w-16"
  >
    <MessageCircle strokeWidth={1.5} className="h-7 w-7" />
  </a>
);
